import { render } from "./sysInfoPanel.vue?vue&type=template&id=ddf690be&scoped=true"
import script from "./sysInfoPanel.vue?vue&type=script&lang=ts"
export * from "./sysInfoPanel.vue?vue&type=script&lang=ts"

import "./sysInfoPanel.vue?vue&type=style&index=0&id=ddf690be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ddf690be"

export default script